var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{attrs:{"icon":"download","disabled":_vm.disabled,"loading":_vm.loading,"type":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.downloadFileList.apply(null, arguments)}}},[_vm._v(" 一键下载 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }